import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiLink, FiEye } = FiIcons;

const lore = [
  {
    icon: FiMapPin,
    title: 'The Ley-Line',
    text: 'A small, overlooked convergence of magic beneath Magnolia, and the prize a corporate sorcerer wants to own.'
  },
  {
    icon: FiLink,
    title: 'The Claim',
    text: 'Magic runs on ownership. Contracts bind people and things, and every spell leaves a debt that never forgets.'
  },
  {
    icon: FiEye,
    title: 'The Unclaimed',
    text: 'Wyatt belongs to no one, which makes him rare, unpredictable, and a target for whoever moves first.'
  }
];

export default function WorldSection() {
  return (
    <section className="world-section" id="world">
      <div className="world-image" />
      <motion.div
        className="world-content"
        initial={{ opacity: 0, x: 35 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        <p className="eyebrow">Nine days in Texas</p>
        <h2>Welcome to <em>Magnolia</em></h2>
        <p className="world-lead">
          By day, it is a quiet town north of Houston: gas stations, porch swings, and neighbors who have known each other for forty years. By night, the magic beneath it is worth killing for.
        </p>
        <div className="lore-list">
          {lore.map((item) => (
            <div className="lore-item" key={item.title}>
              <SafeIcon icon={item.icon} />
              <div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
